<div class="relative">
  <p-autoComplete
    [(ngModel)]="selectedCompany"
    [suggestions]="searchResults()"
    (completeMethod)="search($event)"
    (keydown.enter)="onEnterKey($event)"
    optionLabel="ticker"
    placeholder="Search stocks..."
    [minLength]="1"
    [delay]="0"
    [showEmptyMessage]="false"
    (onSelect)="onCompanySelect($event.value)"
    inputStyleClass="px-4 py-2 pl-10 text-sm bg-background border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
    styleClass="w-64"
  >
    <ng-template let-company #item>
      <app-company-display
        [clickable]="false"
        [ticker]="company.ticker"
        [companyName]="company.companyName"
        [logoUrl]="company.image"
      ></app-company-display>
    </ng-template>
  </p-autoComplete>
</div>
